import { render, staticRenderFns } from "./sbSetupSorgenteDati.vue?vue&type=template&id=4fa390c2"
import script from "./sbSetupSorgenteDati.vue?vue&type=script&lang=js"
export * from "./sbSetupSorgenteDati.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports